import api from '@/api'

const SET_ADDITIONALS = 'SET_ADDITIONALS'

const SET_CURRENT_ADDITIONAL = 'SET_CURRENT_ADDITIONAL'
const UNSET_CURRENT_ADDITIONAL = 'UNSET_CURRENT_ADDITIONAL'

export default {
  namespaced: true,

  state () {
    return {
      additionals: [],
      currentAdditional: null
    }
  },

  getters: {
    additionals: (state) => state.additionals,
    currentAdditional: (state) => state.currentAdditional
  },

  mutations: {
    [SET_ADDITIONALS] (state, data) {
      state.additionals = data
    },

    [SET_CURRENT_ADDITIONAL] (state, data) {
      state.currentAdditional = data
    },

    [UNSET_CURRENT_ADDITIONAL] (state) {
      state.currentAdditional = null
    }
  },

  actions: {
    async loadAdditionals ({ commit }, params) {
      const filters = { farm: params.farm }
      const { data } = await api.additional.list(filters)
      commit(SET_ADDITIONALS, data)
    },

    async createAdditional ({ dispatch }, payload) {
      const { error } = await api.additional.create(payload)
      const filters = { farm: payload.farm }
      dispatch('loadAdditionals', filters)
      return error
    },

    async openAdditionalDetail ({ commit }, id) {
      const { data } = await api.additional.getById(id)
      commit(SET_CURRENT_ADDITIONAL, data)
    },

    async saveAdditional ({ commit, dispatch, getters }) {
      const item = getters.currentAdditional
      const { error } = await api.additional.updateById(item.id, item)
      const params = { farm: item.farm }
      dispatch('loadAdditionals', params)
      commit(UNSET_CURRENT_ADDITIONAL)
      return error
    },

    async deleteAdditional ({ commit, dispatch, getters }) {
      const item = getters.currentAdditional
      await api.additional.deleteById(item.id)
      const params = { farm: item.farm }
      dispatch('loadAdditionals', params)
      commit(UNSET_CURRENT_ADDITIONAL)
    },

    closeAdditional ({ commit }) {
      commit(UNSET_CURRENT_ADDITIONAL)
    }
  }
}
